import React, { useEffect, useState, Component } from 'react';
import { MapComponent } from './MapComponent';
export const GoogleMapComponent = () => {
  const [useLeaflet, setUseLeaflet] = useState(true);
  useEffect(() => {
    // Check if we should show a message about setting up Google Maps
    const hasShownMessage = localStorage.getItem('mapMessageShown');
    if (!hasShownMessage) {
      console.info("To use Google Maps, you'll need to add your API key in GoogleMapComponent.tsx and uncomment the Google Maps implementation. For now, using Leaflet as a fallback.");
      localStorage.setItem('mapMessageShown', 'true');
    }
  }, []);
  // Use the Leaflet implementation instead since it doesn't require an API key
  return <MapComponent data-id="element-121" />;
};
/*
  GOOGLE MAPS IMPLEMENTATION:
  To use Google Maps instead of Leaflet:
  1. Get an API key from https://developers.google.com/maps/documentation/javascript/get-api-key
  2. Install @react-google-maps/api with: npm install @react-google-maps/api
  3. Replace the component above with this implementation:
import React from 'react'
import { useLoadScript, GoogleMap, MarkerF } from '@react-google-maps/api'
const mapContainerStyle = {
  height: '100%',
  width: '100%',
  borderRadius: '0.5rem',
  minHeight: '250px',
}
// Coordinates for 296 Francis Baard Street, Pretoria
const center = {
  lat: -25.7461,
  lng: 28.1881,
}
export const GoogleMapComponent = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_API_KEY_HERE",
  })
  if (loadError) {
    return (
      <div className="h-full min-h-[250px] bg-gray-800 rounded-lg flex items-center justify-center text-red-500 p-4 text-center">
        Error loading maps. Please check your API key.
      </div>
    )
  }
  if (!isLoaded) {
    return (
      <div className="h-full min-h-[250px] bg-gray-800 rounded-lg animate-pulse"></div>
    )
  }
  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={15}
      center={center}
      options={{
        styles: [
          {
            elementType: 'geometry',
            stylers: [{ color: '#242f3e' }],
          },
          // ... other styles ...
        ],
      }}
    >
      <MarkerF position={center} title="Binary Solutions 101010" />
    </GoogleMap>
  )
}
*/